'use client';

import { CustomImage } from 'components/shared';
import { FC } from 'react';
import styles from './Card.module.css';

export interface CardProps {
  className?: string;
  title: string;
  description: string;
  imgSrc: string;
  link: string;
  cardTheme: 'light' | 'dark';
  cta: string;
  onClick: () => void;
}

export const Card: FC<CardProps> = ({
  className,
  title,
  description,
  imgSrc,
  cardTheme,
  cta,
  onClick,
}) => {
  return (
    <div className={`${styles.cardContainer} ${className} ${cardTheme}`}>
      <div className={styles.imgContainer}>
        <CustomImage src={imgSrc} alt={title} fill />
      </div>
      <div className={styles.textContainer}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        <div className={styles.filler} />
        <button className={styles.buyLink} onClick={onClick}>
          {cta}
        </button>
      </div>
    </div>
  );
};
